"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gallery_large_active_svg_1 = __importDefault(require("@assets/Settings/gallery_large_active.svg"));
var gallery_medium_active_svg_1 = __importDefault(require("@assets/Settings/gallery_medium_active.svg"));
var no_gallery_active_svg_1 = __importDefault(require("@assets/Settings/no_gallery_active.svg"));
var Button_1 = __importDefault(require("@components/Button"));
var SwitchBox_1 = __importDefault(require("@components/SwitchBox"));
var moderationSettingsSlice_1 = require("@features/SettingsPage/state/moderationSettingsSlice");
var _i18n_1 = __importDefault(require("@i18n"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var _store_1 = require("@store");
var DraggableSectionItem_1 = __importDefault(require("./DraggableSectionItem"));
var isBoolean = function (value) { return value === true || value === false; };
var SECTIONS = [
    { label: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.ITEM_DETAILS'), id: 'item_details_index' },
    { label: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.USER_DETAILS'), id: 'user_details_index' },
    { label: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.LOCATION_DETAILS'), id: 'location_details_index' },
    { label: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.USER_AGENT_DETAILS'), id: 'user_agent_index' },
];
var IMAGE_GALLERIES = [
    { id: 0, src: no_gallery_active_svg_1.default, name: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.IMAGE_SIZE.NO_IMAGE') },
    { id: 1, src: gallery_medium_active_svg_1.default, name: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.IMAGE_SIZE.MEDIUM') },
    { id: 2, src: gallery_large_active_svg_1.default, name: _i18n_1.default.t('settings:MODERATION_INTERFACE.LAYOUT.IMAGE_SIZE.LARGE') },
];
var TEMPLATE_SECTION_OFF = -1;
var MAX_ITEMS_PER_PAGE = 20;
var MIN_ITEMS_PER_PAGE = 1;
function ModerationSetting(props) {
    var t = (0, react_i18next_1.useTranslation)(['settings', 'common']).t;
    var domain = props.domain;
    var dispatch = (0, _store_1.useAppDispatch)();
    var moderationSettings = (0, react_redux_1.useSelector)(moderationSettingsSlice_1.moderationSettingsSelector);
    var _a = (0, react_hook_form_1.useForm)(), register = _a.register, handleSubmit = _a.handleSubmit, control = _a.control, errors = _a.formState.errors;
    var _b = __read((0, react_1.useState)([]), 2), sections = _b[0], setSections = _b[1];
    var submit = function (formData) {
        if (sections) {
            var formDataTransformed = sections.reduce(function (accumulator, section, index) {
                var value = accumulator.templateValue[section.id];
                accumulator.template[section.id] = value ? index : TEMPLATE_SECTION_OFF;
                return accumulator;
            }, formData);
            var templateValue = formDataTransformed.templateValue, formDataToSend = __rest(formDataTransformed, ["templateValue"]);
            dispatch((0, moderationSettingsSlice_1.persistModerationSettings)(domain, formDataToSend));
        }
    };
    (0, react_1.useEffect)(function () {
        if (moderationSettings && 'template' in moderationSettings) {
            var template_1 = moderationSettings.template;
            var sortedSections = SECTIONS.sort(function (a, b) {
                var aIndex = template_1[a.id];
                var bIndex = template_1[b.id];
                if (aIndex === TEMPLATE_SECTION_OFF) {
                    return 1;
                }
                if (bIndex === TEMPLATE_SECTION_OFF) {
                    return -1;
                }
                return aIndex - bIndex;
            });
            setSections(sortedSections);
        }
    }, [moderationSettings]);
    (0, react_1.useEffect)(function () {
        dispatch((0, moderationSettingsSlice_1.fetchModerationSettings)(domain));
    }, [domain]);
    var onDragEnd = function (result) {
        var source = result.source, destination = result.destination;
        if (!destination)
            return;
        var newSections = Array.from(sections);
        var _a = __read(newSections.splice(source.index, 1), 1), newOrder = _a[0];
        newSections.splice(destination.index, 0, newOrder);
        setSections(newSections);
    };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "moderation-settings" }, moderationSettings && (react_1.default.createElement("form", null,
            react_1.default.createElement("div", { className: "setting__title" }, t('settings:MODERATION_INTERFACE.TITLE')),
            react_1.default.createElement("div", { className: "moderation-settings__section" },
                react_1.default.createElement("div", { className: "moderation-setting__section__title" }, t('settings:MODERATION_INTERFACE.GENERAL.TITLE')),
                react_1.default.createElement("div", { className: "moderation-setting__config-item" },
                    react_1.default.createElement("div", { className: "moderation-setting__config-item__text-container" },
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__name" }, t('settings:MODERATION_INTERFACE.GENERAL.ITEM_PER_PAGE')),
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__text" }, t('settings:MODERATION_INTERFACE.GENERAL.ITEM_PER_PAGE_DESCRIPTION'))),
                    react_1.default.createElement("div", { className: "moderation-setting__config-item__input-container" },
                        react_1.default.createElement("input", __assign({ className: (0, clsx_1.default)('moderation-setting__config-item__input', errors.display_per_page && 'eva-input--invalid'), type: "number", autoComplete: "off", defaultValue: moderationSettings.display_per_page }, register('display_per_page', {
                            required: true,
                            validate: function (value) { return value <= MAX_ITEMS_PER_PAGE && value >= MIN_ITEMS_PER_PAGE; },
                        }))),
                        react_1.default.createElement("p", { className: "setting__error" }, errors.display_per_page &&
                            t('settings:MODERATION_INTERFACE.GENERAL.ITEM_PER_PAGE_ERROR', {
                                MIN: MIN_ITEMS_PER_PAGE,
                                MAX: MAX_ITEMS_PER_PAGE,
                            })))),
                react_1.default.createElement("div", { className: "moderation-setting__config-item" },
                    react_1.default.createElement("div", { className: "moderation-setting__config-item__text-container" },
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__name" }, t('settings:MODERATION_INTERFACE.GENERAL.PRESELECT_APPROVE')),
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__text" }, t('settings:MODERATION_INTERFACE.GENERAL.PRESELECT_APPROVE_DESCRIPTION'))),
                    react_1.default.createElement(react_hook_form_1.Controller, { name: "default_preapprove", control: control, defaultValue: moderationSettings.default_preapprove, rules: { validate: isBoolean }, render: function (_a) {
                            var field = _a.field;
                            return (react_1.default.createElement(SwitchBox_1.default, { name: "default_preapprove", checked: field.value, onToggle: function () { return field.onChange(!field.value); } }));
                        } })),
                react_1.default.createElement("div", { className: "moderation-setting__config-item" },
                    react_1.default.createElement("div", { className: "moderation-setting__config-item__text-container" },
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__name" }, t('settings:MODERATION_INTERFACE.GENERAL.ALLOW_AMENDMENT')),
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__text" }, t('settings:MODERATION_INTERFACE.GENERAL.ALLOW_AMENDMENT_DESCRIPTION'))),
                    react_1.default.createElement(react_hook_form_1.Controller, { name: "post_review_enabled", control: control, defaultValue: moderationSettings.post_review_enabled, rules: { validate: isBoolean }, render: function (_a) {
                            var field = _a.field;
                            return (react_1.default.createElement(SwitchBox_1.default, { name: "post_review_enabled", checked: field.value, onToggle: function () { return field.onChange(!field.value); } }));
                        } }))),
            react_1.default.createElement("div", { className: "moderation-settings__section" },
                react_1.default.createElement("div", { className: "moderation-setting__section__title" }, t('settings:MODERATION_INTERFACE.LAYOUT.TITLE')),
                react_1.default.createElement("div", { className: "moderation-setting__config-item__text-container__name" }, t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.TITLE')),
                react_1.default.createElement("div", { className: "moderation-setting__config-item__text-container__text" }, t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.TEXT')),
                react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEnd },
                    react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "sections" }, function (provided) { return (react_1.default.createElement("div", __assign({ className: "moderation-settings__change-template-order" }, provided.droppableProps, { ref: provided.innerRef }),
                        react_1.default.createElement("div", { className: "moderation-settings__change-template-order__header" },
                            react_1.default.createElement("div", null, t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.SECTION_NAME_LABEL')),
                            react_1.default.createElement("div", null, t('settings:MODERATION_INTERFACE.LAYOUT.SECTIONS.DISPLAY_SECTION_LABEL'))),
                        sections &&
                            sections.map(function (section, index) { return (react_1.default.createElement(react_hook_form_1.Controller, { key: section.id, name: "templateValue.".concat(section.id), control: control, defaultValue: moderationSettings.template[section.id] !== TEMPLATE_SECTION_OFF, rules: { validate: isBoolean }, render: function (_a) {
                                    var field = _a.field;
                                    return (react_1.default.createElement(DraggableSectionItem_1.default, { value: field.value, onValueChanged: function (value) {
                                            field.onChange(value);
                                        }, section: section, index: index }));
                                } })); }),
                        provided.placeholder)); })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "moderation-setting__config-item__text-container" },
                        react_1.default.createElement("span", { className: "moderation-setting__config-item__text-container__name" }, t('settings:MODERATION_INTERFACE.LAYOUT.IMAGE_SIZE.TITLE'))),
                    react_1.default.createElement(react_hook_form_1.Controller, { name: "template.image_gallery_id", control: control, defaultValue: moderationSettings.template.image_gallery_id, rules: { required: true }, render: function (_a) {
                            var field = _a.field;
                            return (react_1.default.createElement("div", { className: "moderation-setting__select-image-gallery" }, IMAGE_GALLERIES.map(function (gallery, index) { return (react_1.default.createElement("div", { key: index, onClick: function () { return field.onChange(gallery.id); }, className: (0, clsx_1.default)('moderation-setting__select-image-gallery__option', field.value === gallery.id && 'moderation-setting__select-image-gallery__option--active') },
                                react_1.default.createElement("img", { className: "moderation-setting__select-image-gallery__option__image", src: gallery.src }),
                                react_1.default.createElement("div", { className: "moderation-setting__select-image-gallery__option__text" }, gallery.name))); })));
                        } }))),
            react_1.default.createElement(Button_1.default, { text: t('common:COMMON.SAVE_CHANGES_BUTTON'), onClick: handleSubmit(submit), className: "save-changes-btn" }))))));
}
exports.default = ModerationSetting;
